import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { OfferPreviewCancelCommandResult, OfferPreviewCheckoutCommandResult, OfferPreviewGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IOfferPreviewApiService {

  abstract offerPreviewGet(
    cartNumber: number,
    validateCart?: boolean | undefined
  ): Observable<OfferPreviewGetQueryResult>;

  abstract offerPreviewCheckout(cartNumber: number): Observable<OfferPreviewCheckoutCommandResult>;

  abstract offerPreviewCancel(shoppingCartNumber: number): Observable<OfferPreviewCancelCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IOfferPreviewApiServiceToken = new InjectionToken<IOfferPreviewApiService>('IOfferPreviewApiServiceToken');
